import { render } from "./MatchWise.vue?vue&type=template&id=e92e5116"
import script from "./MatchWise.vue?vue&type=script&lang=js"
export * from "./MatchWise.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__